var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.320312,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#007D52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.3203C9 21.8507 9.21071 22.3595 9.58579 22.7345C9.96086 23.1096 10.4696 23.3203 11 23.3203C11.5304 23.3203 12.0391 23.1096 12.4142 22.7345C12.7893 22.3595 13 21.8507 13 21.3203M9 21.3203C9 20.7899 9.21071 20.2812 9.58579 19.9061C9.96086 19.531 10.4696 19.3203 11 19.3203C11.5304 19.3203 12.0391 19.531 12.4142 19.9061C12.7893 20.2812 13 20.7899 13 21.3203M9 21.3203H7V17.3203M13 21.3203H19M19 21.3203C19 21.8507 19.2107 22.3595 19.5858 22.7345C19.9609 23.1096 20.4696 23.3203 21 23.3203C21.5304 23.3203 22.0391 23.1096 22.4142 22.7345C22.7893 22.3595 23 21.8507 23 21.3203M19 21.3203C19 20.7899 19.2107 20.2812 19.5858 19.9061C19.9609 19.531 20.4696 19.3203 21 19.3203C21.5304 19.3203 22.0391 19.531 22.4142 19.9061C22.7893 20.2812 23 20.7899 23 21.3203M23 21.3203H25V15.3203M6 9.32031H17V21.3203M25 15.3203H17M25 15.3203L22 10.3203H17M7 13.3203H11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliver);
export default __webpack_public_path__ + "static/media/Deliver.765fd39bbfac7b64e980f17f4a1e316b.svg";
export { ForwardRef as ReactComponent };